import script from "./Topic.vue?vue&type=script&setup=true&lang=ts"
export * from "./Topic.vue?vue&type=script&setup=true&lang=ts"

import "./Topic.vue?vue&type=style&index=0&id=3f06bbf0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f06bbf0"]])

export default __exports__